<template>
    <div class="msg">
        <div class="user-mes-box">
            <div class="user-mes-title" v-text="addText"></div>
            <div class="user-mes">
                <div v-show="!isHsR">
                    <div class="user-mes-in cle" v-for="(items,index) in mes" :key="index">
                        <div v-text="items.name" class="user-mes-name fl" :title="items.name"></div>
                        <input :disabled="index===0||mes.length-1===index" :type="items.type" v-model="items.val" maxlength="60" class="user-mes-inp fr">
                    </div>
                </div>
                <div v-show="isHsR">
                    <div class="user-mes-in-top" v-for="(items,index) in mesHs" :key="index">
                        <div class="user-mes-in cle" v-show="items.sh">
                            <div v-text="items.name" class="user-mes-name fl" :title="items.name"></div>
                            <input :type="items.type" :disabled="index===0||mesHs.length-1===index||items.disabled" v-model="items.val" maxlength="60" class="user-mes-inp fr">
                        </div>
                    </div>
                </div>
                <div class="user-mes-btn cle">
                    <button type="button" class="fl" @click="confirm" :title="confirmText" v-text="confirmText"></button>
                    <button type="button" class="fr" @click="cancle" :title="cancleText" v-text="cancleText"></button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import edit from '../assets/js/bomb'
export default {
    name:'EditDevice',
    props:['language','cloudId','name','upo','num','isChange','isHs'],
    data(){
        return{
            addText:this.lanNow.lan['K035_ModifyDevice'],
            mes:[
                {name:this.lanNow.lan['K004_CloudID'],type:'text',val:''},
                {name:this.lanNow.lan['K023_DeviceName'],type:'text',val:''},
                {name:this.lanNow.lan['K175_Channel'],type:'text',val:''}
                //   {name:'',type:'text',val:''},
            ],
            mesHs:[
                {name:this.lanNow.lan['K004_CloudID'],type:'text',val:'',sh:true},
                {name:this.lanNow.lan['K023_DeviceName'],type:'text',val:'',sh:true},
                {name:this.lanNow.lan['K005_DeviceUserName'],type:'text',val:'',sh:true},
                {name:this.lanNow.lan['K006_DevicePwd'],type:'password',val:'',sh:true},
                {name:this.lanNow.lan['K175_Channel'],type:'text',val:'',sh:true}
                //   {name:'',type:'text',val:''},
            ],
            confirmText:this.lanNow.lan['K024_Confirm'],
            cancleText:this.lanNow.lan['K018_Cancel'],
            isLang:false,
            isShare:false,
            isHsR:0,
            once:true
        }
    },
    methods:{
        confirm:function(){
            this.ajaxH.repeat=this.confirmAfter;
            this.$emit('refresh');
        },
        confirmAfter:function(){
            var sessionId=this.ajaxH.session;
            var oem=this.baseData.oem;
            var str;
            var confirmData;
            if(this.isHsR){
                if(this.mesHs[1].val===''){
                    alert(this.language["K176_Empty"]);
                    return false;
                };
                var num=this.reg.devName.num;
                var leng=this.StrByteCountFun(this.mesHs[1].val);
                if(!(leng>=num[0]&&length<=num[1])){
                    alert(this.language['K204_Limit']);
                    return false;
                };
                if(!this.reg.devName.limit.test(this.mesHs[1].val)){
                    alert(this.language['K205_Type']);
                    return false;
                };
                if(this.mesHs[2].val===''){
                    alert(this.language["K144_UserEmpty"]);
                    return false;
                };
                var numName=this.reg.devUser.num;
                var lengName=this.StrByteCountFun(this.mesHs[2].val);
                if(!(lengName>=numName[0]&&lengName<=numName[1])){
                    alert(this.language['K206_Limit']);
                    return false;
                };
                if(!this.reg.devUser.limit.test(this.mesHs[2].val)){
                    alert(this.language['K209_Type']);
                    return false;
                };
                var numPwd=this.reg.devPwd.num;
                var lengPwd=this.StrByteCountFun(this.mesHs[3].val);
                if(!(lengPwd>=numPwd[0]&&lengPwd<=numPwd[1])){
                    alert(this.language['K208_Limit']);
                    return false;
                };
                if(!this.reg.devPwd.limit.test(this.mesHs[3].val)){
                    alert(this.language['K210_Type']);
                    return false;
                };
                if (this.isHsR === 3) {
                    confirmData = {
                        "header": {
                            "client": {
                                "app": "",
                                "id": "",
                                "oem": oem,
                                "type": 3
                            },
                            "command": "device-update-by-id",
                            "flag": "tdkcloud",
                            "seq": 0,
                            "session": sessionId,
                            "user-data": "",
                            "version": "v1.20"
                        },
                        "content": {
                            "duid": this.mesHs[0].val,
                            "device-name": this.mesHs[1].val,
                            "device-user": this.mesHs[2].val,
                            "device-pwd": this.mesHs[3].val
                        }
                    }
                } else {
                    str=edit.editDeviceSet({
                        sessionId:sessionId,
                        oem:oem,
                        id:this.mesHs[0].val,
                        name:this.mesHs[1].val,
                        isChange:this.isShare,
                        isHs:this.isHsR
                    });
                }
            }else{
                if(this.mes[1].val===''){
                    alert(this.language["K176_Empty"]);
                    return false;
                };
                var num=this.reg.devName.num;
                var leng=this.StrByteCountFun(this.mes[1].val);
                if(!(leng>=num[0]&&length<=num[1])){
                    alert(this.language['K204_Limit']);
                    return false;
                };
                if(!this.reg.devName.limit.test(this.mes[1].val)){
                    alert(this.language['K205_Type']);
                    return false;
                };
                str=edit.editDeviceSet({
                    sessionId:sessionId,
                    oem:oem,
                    id:this.mes[0].val,
                    name:this.mes[1].val,
                    isChange:this.isShare,
                    isHs:this.isHsR
                });
            };
            var data;
            if (this.isHsR === 3) {
                data=this.ajaxSet({
                    ip:this.cloudName,
                    type:'auth/user',
                    cType: 'json',
                    xml:JSON.stringify(confirmData)
                });
            } else {
                data=this.ajaxSet({
                    ip:this.cloudName,
                    type:'auth/user',
                    xml:str
                });
            }
            this.confirmResult(data.data);
        },
        confirmResult:function(data){
            if(!data){
                this.$emit('msgHides',{hide:false,suc:false});
            }else{
                var result;
                if (data.header) {
                    result=(data.header || {}).result;
                } else {
                    result=$(data).find('header').find('result').text()-0;
                }
                var key = this.promptInfo(result);
                if(result===0){
                    if(this.isHsR&&this.isHsR!==3&&this.once){
                        if(this.isShare){
                            this.once=true;
                            this.ajaxH.repeat=function(){};
                            this.$emit('msgHides',{hide:false,suc:true});
                            alert(this.language["K116_Modify_Successfully"]);
                        }else{
                            this.once=false;
                            this.confirmHs();
                        };
                    }else{
                        this.once=true;
                        this.ajaxH.repeat=function(){};
                        this.$emit('msgHides',{hide:false,suc:true});
                        alert(this.language["K116_Modify_Successfully"]);
                        if (this.isHsR === 3) {
                            this.$emit('refresh');
                        }
                    };
                }else{
                    this.once=true;
                    this.$emit('msgHides',{hide:false,suc:false});
                    alert(this.language[key] == undefined ? key : this.language[key]);
                };
            };
        },
        confirmHs:function(){
            var sessionId=this.ajaxH.session;
            var oem=this.baseData.oem;
            var str=edit.editDeviceSetHs({
                sessionId:sessionId,
                oem:oem,
                id:this.mesHs[0].val,
                upo:JSON.stringify({user:this.mesHs[2].val,pwd:this.mesHs[3].val})
            });
            var data=this.ajaxSet({
                ip:this.cloudName,
                type:'auth/user',
                xml:str
            });
            this.confirmResult(data.data);
        },
        cancle:function(){
            this.$emit('msgHides',{hide:false,suc:false});
        },
        lang:function(){
            this.mes[0].val=this.cloudId;
            this.mes[1].val=this.name;
            this.mes[2].val=this.num;
            this.isShare=this.isChange;
            this.isHsR=this.isHs;
            
            if(this.isHsR){
                this.mesHs[2].disabled=false;
                this.mesHs[0].val=this.cloudId;
                this.mesHs[1].val=this.name;
                var obj=JSON.parse(this.upo);
                this.mesHs[2].val=obj.user;
                if (this.isHs === 3) {
                    this.mesHs[2].disabled=true;
                }
                this.mesHs[3].val=obj.pwd;
                this.mesHs[4].val=this.num;
                if(this.isShare){
                    this.mesHs[2].sh=false;
                    this.mesHs[3].sh=false;
                }else{
                    this.mesHs[2].sh=true;
                    this.mesHs[3].sh=true;
                };
            };
            //   this.mes[2].val='';
            //   this.mes[3].val='';
            var _that=this;
            if(!this.isLang){
                this.isLang=true;
            };

        }
    }
}
</script>
<style scoped>
    .msg{
        position:fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background-color:rgba(0, 0, 0, .5);
    }
    .user-mes-box{
        width:400px;
        height:300px;
        background-color: #EFF2F9;
        font-size:12px;
        position:absolute;
        top:50%;
        left:50%;
        margin-top:-150px;
        margin-left:-200px;
    }
    .user-mes-title{
        width:100%;
        height:24px;
        line-height:24px;
        text-align: center;
        background-color: #364860;
        color:#fff;
    }
    .user-mes{
        width:100%;
        height:calc(100% - 24px);
        padding:20px;
        box-sizing: border-box;
    }
    .user-mes-in{
        width:100%;
        height:30px;
    }
    .user-mes-in+.user-mes-in{
        margin-top:10px;
    }
    .user-mes-in-top+.user-mes-in-top{
        margin-top:10px;
    }
    .user-mes-name{
        width:120px;
        height:100%;
        line-height:30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .user-mes-inp{
        width:calc(100% - 120px - 20px);
        height: 100%;
        box-sizing: border-box;
        border:1px solid #ccc;
        outline: none;
    }
    .user-mes-btn{
        width:100%;
        height:30px;
        margin-top:10px;
    }
    .user-mes-btn button{
        width:80px;
        height:100%;
        background-color: #EFF2F9;
        box-sizing: border-box;
        border:1px solid #364860;
        outline: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
</style>
<style scoped>
    @import '../assets/css/cloudPop.css';  
</style>





// WEBPACK FOOTER //
// src/components/EditDevice.vue